<template>
    <div>
        <div class="header">
            <div class="headAll">
                <div class="logo">
                    <img src="../../assets/img/logo.png" alt="">
                    {{ title === '2' ? '全国田径专业人员管理系统-成绩录入' : '成绩证书打印' }}
                </div>
            </div>
        </div>
        <div class="main">
            <div class="center">
                <div class="loginImg">
                    <img src="../../assets/img/pic3.png" alt="" class="animated fadeInLeft">
                </div>
                <div class="login animated fadeInDown">
                    <div class="loginAll">
                        <div class="loginTitle">用户登录</div>
                        <div class="loginForm">
                            <Form ref="formInline" :model="formInline" :rules="ruleInline" :label-width="80">
                                <FormItem label="用户名：" prop="username">
                                    <Input @keyup.enter.native="handleSubmit('formInline')" type="text"
                                        placeholder="请输入用户名" v-model="formInline.username">
                                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                                    </Input>
                                </FormItem>
                                <FormItem label="密码：" prop="password">
                                    <Input @keyup.enter.native="handleSubmit('formInline')" type="password"
                                        v-model="formInline.password" placeholder="请输入密码">
                                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                                    </Input>
                                </FormItem>
                                <FormItem label="验证码：" prop="code">
                                    <Input @keyup.enter.native="handleSubmit('formInline')" type="text"
                                        v-model="formInline.code" placeholder="请输入验证码">
                                    <Icon type="ios-key-outline" slot="prepend"></Icon>
                                    </Input>
                                    <img :src="imgCode" class="yzmImg" @click="getCodeData" />
                                </FormItem>
                                <FormItem>
                                    <Button size="large" type="primary" @click="handleSubmit('formInline')" long>登
                                        录</Button>
                                    <Button style="margin-top: 12px;width:100%" @click="isShow = true"
                                        size="large">个人证书打印</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <p>
                <span>地址：深圳市宝安区航城街道三围社区置富兆业科创园A 栋A501&emsp;</span>
                <span>联系电话：0755-86379837（工作日 9:00-18:00）</span>
            </p>
            <p>中国田径协会©版权所有 本系统由深圳市菲普莱体育发展有限公司提供技术支持（请使用IE10以上浏览器）</p>
            <p>
                <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备19015564号-4</a>
                 &emsp;
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002009222" rel="noreferrer" target="_blank">粤公网安备44030002009222号</a >
            </p>
           
        </div>
        <Modal :mask-closable="false" v-model="isShow" title="个人证书打印" :footerHide="true" width="500">
            <div class="ewm">
                <Alert type="success" show-icon>
                    温馨提示：请使用微信扫描下方二维码，注册账号登录可以下载证书！
                </Alert>
                <img v-if="isFairplay" src="@/assets/img/ewm2.png" alt="">
                <img v-else src="@/assets/img/ewm.png" alt="">
            </div>

        </Modal>
    </div>
</template>

<script>
import { login, getAllUnit, getUserUnitList, getInfo } from '@/lib/api/'
export default {
    props: ['title', 'ti', 'gameid'],
    data() {
        return {
            isFairplay: false, // 
            isShow: false,
            sportsmanListModal: false,
            authorities: [],
            imgCode: '',
            pageid: '',
            // 单位数据
            formInline: {
                username: '',
                password: '',
                grant_type: 'password'
            },
            ruleInline: {
                username: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    //   { type: 'string', min: 6, message: '密码长度不能小于6位数' }
                ],
                code: [
                    { required: true, message: '验证码不能为空', trigger: 'blur' },
                    { type: 'string', min: 4, message: '验证码错误' }
                ],
            }
        }
    },
    methods: {

        handleSubmit(name) {
            this.$refs[name].validate((valid) => {

                if (valid) {

                    let data = this.formInline;
                    data.pageid = this.pageid;
                    // data.registerNo =parseInt(this.formInline.company);
                    if (this.title != 2) {
                        data.source = 'web_signup';
                        if (this.gameid) {
                            data.gamecode = this.gameid;
                        }

                    }
                    data = this.$qs.stringify(data);

                    login(data).then((res) => {

                        if (res.data.access_token != null) {

                            data = this.$qs.parse(data)

                            this.authorities = [];

                            for (let i = 0; i < res.data.authorities.length; i++) {
                                if (this.gameid) {
                                    if (res.data.authorities[i] == this.$PlugIn.role.print || res.data.authorities[i] == this.$PlugIn.role.admin) {
                                        this.authorities.push(res.data.authorities[i]);
                                        // 存储登录信息
                                        if (res.data.authorities[i] == this.$PlugIn.role.print && !localStorage.titles) {
                                            localStorage.titles = '1'
                                        }
                                    }
                                } else {
                                    if (res.data.authorities[i] == this.$PlugIn.role.countriesEntry || res.data.authorities[i] == this.$PlugIn.role.print || res.data.authorities[i] == this.$PlugIn.role.admin || res.data.authorities[i] == this.$PlugIn.role.entryAdmin || res.data.authorities[i] == this.$PlugIn.role.unitEntry || res.data.authorities[i] == this.$PlugIn.role.countriesEntry) {
                                        this.authorities.push(res.data.authorities[i]);
                                        // 存储登录信息
                                        if (res.data.authorities[i] == this.$PlugIn.role.print && !localStorage.titles) {
                                            localStorage.titles = '1'
                                        }
                                    }
                                }

                            }
                            if (this.authorities.length) {

                                localStorage.authorities = JSON.stringify(this.authorities)
                                localStorage.loginDataAll = res.data.username;
                                localStorage.Token = res.data.access_token;
                                localStorage.refresh_token = res.data.refresh_token;
                                localStorage.unitType = res.data.unitType;
                                localStorage.scoreEntryId = res.data.id;
                                if (res.data.unitName) {
                                    localStorage.unitName = res.data.unitName
                                } else {
                                    localStorage.unitName = ''
                                }
                                this.getUserUnitListF(res.data.id);
                            } else {
                                this.$Message.error('该用户没有权限');
                            }

                        } else {
                            this.$Message.error(res.data.msg);
                        }
                    });
                } else {
                    this.$Message.error('请完善信息后再登录');
                }
            })
        },
        getUserUnitListF(id) {
            getUserUnitList(id).then(res2 => {
                if (res2.data.code == 0) {
                    if (res2.data.data.length) {
                        localStorage.unit = JSON.stringify(res2.data.data[0].unitNameCHN);
                        localStorage.userID = res2.data.data[0].userID;
                        localStorage.unitID = res2.data.data[0].unitID;
                    }

                } else if (res2.data.code == -2) {
                    this.$Message.error("网络连接失败");
                } else if (res2.data.code == 10) {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                } else {
                    this.$Message.error(res2.data.msg);
                }
            }, err => {
                this.$Message.error("网络连接失败");
            });
            if (this.title != 2) {
                if (this.gameid) {
                    this.$router.push({
                        path: '/printCertificate',
                        query: { gameID: this.gameid, title: this.ti }
                    });
                } else {
                    this.$router.push({
                        path: '/List',
                    });
                }
            } else {
                getInfo().then(res2 => {//获取用户信息
                    if (res2.data.code == 0) {
                        this.$Message.success('恭喜您！登录成功');
                        if (res2.data.data.email) {
                            localStorage.email = res2.data.data.email;
                        }
                        if (res2.data.data.mobile) {
                            localStorage.mobile = res2.data.data.mobile;
                        }

                        if (localStorage.authorities.indexOf(this.$PlugIn.role.roleAwardAdmin) != -1) {

                            if (this.gameid) {
                                this.$router.push({
                                    path: '/printCertificate',
                                    query: { gameID: this.gameid, title: this.ti }
                                });
                            } else {
                                this.$router.push({
                                    path: '/List',
                                });
                            }

                        } else {
                            this.$router.push({
                                path: '/sportermeeting',
                            });
                        }

                    } else if (res2.data.code == -2) {
                        this.$Message.error("网络连接失败");
                    } else if (res2.data.code == 10) {
                        this.$Message.info("登录token过期请重新登录");
                        this.$store.dispatch('loginOut');
                    } else {
                        this.$Message.error(res2.data.msg);
                    }
                }, err => {
                    this.$Message.error("网络连接失败");
                });
            }

        },
        //获取验证码
        getCodeData() {
            var timestamp = Date.parse(new Date());
            this.pageid = Math.random() * timestamp;
            this.imgCode = `${this.$imgUrl}/api/login/code?pageid=${this.pageid}`;
        }
    },
    created() {
        this.getCodeData();
        const domain = window.location.hostname;
        this.isFairplay = window.location.hostname.includes("inputscore.athlete.fairplay.xin") ? true :false;
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.ewm {
    text-align: center;
    img{
        width: 400px;
    }
}

.qqimg {
    right: 0;
    top: 8px;
    text-align: center;
}

.footerMain {
    margin: 0 auto;
    width: 422px;
    text-align: left;
    padding-top: 12px;
}

.heightAuto {
    height: auto;
    overflow: hidden;

}

.header {
    height: 90px;
    line-height: 90px;
    background-color: #deecfe;

    .headAll {
        width: 1100px;
        .heightAuto();
        margin: 0 auto;

        .logo {
            float: left;
            font-size: 24px;
            color: #0098e6;
            font-weight: bold;

            img {
                float: left;
                margin-right: 15px;
                width: 60px;
                margin-top: 13px;
            }
        }

        .logoTxt {
            float: right;
            font-size: 14px;
            color: #999;
            line-height: 60px;
            position: relative;
            top: 40px;
        }
    }
}

.main {
    background: url(../../assets/img/bg.jpg) top repeat;
    .heightAuto();
    padding: 2% 0px;
    background-size: 100% 100%;

    .center {
        width: 1100px;
        .heightAuto();
        margin: 0 auto;

        .login {
            float: right;
            width: 350px;
            padding: 10px;
            border-radius: 10px;
            margin-top: 138px;
            .heightAuto();
            background: url('../../assets/img/login_bg.png') repeat;

            .loginAll {
                background-color: #fff;
                border-radius: 10px;
                padding: 10px;

                .loginTitle {
                    height: 35px;
                    line-height: 30px;
                    text-align: center;
                    border-bottom: 2px #82c3f7 solid;
                    font-size: 16px;
                    color: #333;
                    margin-bottom: 15px;
                }
            }
        }
    }
}

.footer {
    text-align: center;
    line-height: 25px;
    margin-top: 50px;
}

.loginImg {
    float: left;
    width: 750px;
    height: 500px;
    //background: url(../assets/img/pic.png) bottom right no-repeat;
    background-size: 50%;
    top: 100px;
    margin-top: 50px;

    img {
        width: 336px;
        opacity: 0.9;

        margin-top: 65px;
    }
}

.respsw {
    text-align: right;
    position: relative;
    margin-top: 15px;

    a {
        color: #666;
    }
}

.yzmImg {
    position: absolute;
    top: 2px;
    z-index: 100;
    width: 87px;
    height: 30px;
    right: 1px;
}
</style>



// WEBPACK FOOTER //
// src/public/header/head.vue